import { render, staticRenderFns } from "./T1PolitykaPrywatnosci.vue?vue&type=template&id=4bbf7590&scoped=true&"
var script = {}
import style0 from "./T1PolitykaPrywatnosci.vue?vue&type=style&index=0&id=4bbf7590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbf7590",
  null
  
)

export default component.exports